export const question = [
    {
      id: 1,
      question: "Eligibility",
      answer: [
        {
          item: "Financing property owners against future rent receivables",
        },
        {
          item: "Corporates/Entrepreneurs who lease out or propose to lease out their property under ofﬁcial Lease Agreement to reputable institutions/companies such as Government/SemiGovernment/ Public Service Undertakings/Reputed Companies/Bank & Financial Institutions/Multinational Companies etc.",
        },
      ],
    },
    {
      id: 2,
      question: "Purpose",
      answer: [
        {
          item: "For Personal & Business needs",
        }
      ],
    },
    {
      id: 3,
      question: "Security",
      answer: [
        {
          item: "Speciﬁc Assignment of Lease/Rentals",
        },
        {
          item: "Legal mortgage of the leased properties and/or any other acceptable security",
        },
      ],
    },
    {
      id: 4,
      question: "Repayment Period",
      answer: [
        {
          item: "Repayment will be as per cash ﬂows of the business unit for the duration of the facility up to a maximum of 84 months",
        },
      ],
    }
  ];